// extracted by mini-css-extract-plugin
export default {"link":"style_link__ki-Fc","span":"style_span__fWdiA"};